module.exports = __webpack_public_path__ + "img/logo-scmobi.a85261ff.png";